export const setUUID = (data) => {
    return { type: "SET_UUID", payload: data}
}

//Adds interaction functions to single collection in Scene
export const loadDNALadder = (data) => {
    return { type: "LOAD_DNA_LADDER", payload: data}
}

//Adds interaction functions to single collection in Scene
export const prepareGelBox = (data) => {
    return { type: "PREPARE_GELBOX", payload: data}
}

//Adds interaction functions to single collection in Scene
export const runGel = (data) => {
    return { type: "RUN_GEL", payload: data}
}

//Adds interaction functions to single collection in Scene
export const visualizeGel = (data) => {
    return { type: "VISUALIZE_GEL", payload: data}
}


//Set value to object held in scene
export const setProtocolTableData = (object) => {
    return { type: "SET_PROTOCOL_TABLE_DATA", payload: object}
}

//Set value to object held in scene
export const setTableQuestionData = (object) => {
    return { type: "SET_TABLE_QUESTION_DATA", payload: object}
}

//Set value to object held in scene
export const setHeldObject = (object) => {
    return { type: "SET_HELD_OBJECT", payload: object}
}

//Set target list for object for collision detection
export const setTargetList = (targetList) => {
    return { type: "SET_TARGET_LIST", payload: targetList}
}

//Adds interaction functions to single collection in Scene
export const pushInteractions = (interactions) => {
    return { type: "PUSH_INTERACTIONS", payload: interactions}
}

//Records target of last drop for interactions
export const setLastDrop = (data) => {
    //data = {lastHeld, lastTarget}
    return { type: "SET_LAST_DROP", payload: data}
}
//Changes scene scale
export const setSceneScale = (data) => {
    //data = {scale}
    return { type: "SET_SCENE_SCALE", payload: data }
}

//Changes scene scale
export const setUserScale = (data) => {
    //data = {scale}
    return { type: "SET_USER_SCALE", payload: data }
}

export const setupProtocolScene = (data) => {
    //data = {scale}
    return { type: "SETUP_PROTOCOL_SCENE", payload: data }
}

//Increases protocol page by 1
export const incProtocolPage = () => {
    return { type: "INC_PROTOCOL_PAGE", payload: 1}
}

//Decreases protocol page by 1
export const decProtocolPage = () => {
    return { type: "DEC_PROTOCOL_PAGE", payload: 1}
}

//Goes to a specific protocol page
export const goProtocolPage = (page) => {
    return { type: "GO_PROTOCOL_PAGE", payload: page}
}

//Sets total protocol pages
export const setTotalProtocolPages = (total) => {
    return { type: "SET_TOTAL_PROTOCOL_PAGES", payload: total}
}

//Sets task page's top instructions line
export const setPageInstructions = (instructions) => {
    return { type: "SET_PAGE_INSTRUCTIONS", payload: instructions}
}

//Save note to a given task
export const saveTaskNote = (payload) => {
    return { type: "SAVE_TASK_NOTE", payload: payload }
}

//Set tasks data on init (Upgrade to API data later)
export const setTaskPages = (taskPages) => {
    return { type: "SET_TASK_PAGES", payload: taskPages}
}

//Set tasks data on init (Upgrade to API data later)
export const setLevel = (data) => {
    //data = {level}
    return { type: "SET_LEVEL", payload: data}
}

//Sets first task in notebook to focused
export const focusFirstTask = () => {
    return { type: "FOCUS_FIRST_TASK", payload: {} }
}

//Sets focused task to completed
export const setTaskCompleted = (data) => {
    //data = {pageIndex, taskIndex}
    return { type: "SET_TASK_COMPLETED", payload: data }
}

//Sets focused task to completed
export const clearLastActions = () => {
    //data = {pageIndex, taskIndex}
    return { type: "CLEAR_LAST_ACTIONS", payload: {} }
}

//Sets focused task to completed
export const clearTempPoints = () => {
    return { type: "CLEAR_TEMP_POINTS", payload: {} }
}

//DEPRECATED - USE criteriaPassed below
//Sets focused task to completed
export const incTempPoints = () => {
    return { type: "INC_TEMP_POINTS", payload: {} }
}

//Sets focused task to completed
export const criteriaPassed = (data) => {
    //data = {criteria}
    return { type: "CRITERIA_PASSED", payload: data }
}

//Sets toast as fired
export const setToastFired = () => {
    return { type: "SET_TOAST_FIRED", payload: {} }
}

//Set the notes view to be enabled / disabled
export const toggleNotesView = (state) => {
    return { type: "NOTES_VIEW", payload: state}
}

export const saveGelDragDropPrediction = (data) => {
    //data = {attempts}
    return { type: "SAVE_GEL_DRAGDROP_PREDICTION", payload: data }
}

export const setPopupFired = (data) => {
    return { type: "SET_POPUP_FIRED", payload: data }
};

export const labelReactionTubes = (data) => {
    //data = {id, renamed}
    return { type: "RE_LABEL_REACTION_TUBES", payload: data}
}

export const setViewedProtocolReadDialog = (data) => {
    //data = {id, renamed}
    return { type: "VIEWED_PROTOCOL_READ_DIALOG", payload: data}
}
